import * as tslib_1 from "tslib";
import store from '../../store';
import { isWeixin } from '@ivy/fts/utils';
import AlbumCover from './comps/albumCover.vue';
import AlbumList from './comps/albumList.vue';
import ALbumDesc from './comps/albumDesc.vue';
import AlbumAudios from './comps/albumAudios.vue';
import BuyAlbum from './comps/buyAlbum.vue';
import { Component, Vue } from 'vue-property-decorator';
let AlbumPost = class AlbumPost extends Vue {
    constructor() {
        super(...arguments);
        this.album = {}; // 专辑信息
        this.tabActive = 1;
        this.isWeixin = isWeixin();
        this.showPage = false;
    }
    async mounted() {
        await store.login(this);
        const { result, memId, from, id: albumId } = this.$route.query;
        const message = { 'chooseWXPay:ok': '专辑购买成功', 'chooseWXPay:cancel': '支付取消', 'chooseWXPay:fail': '支付失败' };
        if (result) {
            this.$Toast(message[`${result}`] || `${result}`);
        }
        await this.initPage().catch(e => {
            this.$router.push('/ERROR');
        });
        this.showPage = true;
        // 设置分享时显示的图片和标题
        let { title, content: desc, pic_url: imgUrl, url: link } = this.album.share_data;
        store.setupShare({ title, desc, imgUrl, link });
    }
    async paySuccess(res) {
        if (res.r) {
            this.$Toast('专辑购买成功');
            await this.initPage();
        }
    }
    tabBarClick(item = 0) {
        this.tabActive = item;
    }
    async initPage() {
        this.album = {};
        await this.getBigAlbumInfo();
    }
    async getBigAlbumInfo() {
        const { id } = this.$route.query;
        if (!id)
            return this.$Toast('参数错误');
        const { data } = await this.$axios.get(`/api/audios/resource/bigAlbum/getDetail`, {
            params: {
                token: store.logined.token,
                id,
            }
        });
        this.album = data;
        if (this.album.show_page === 'desc') {
            this.tabBarClick();
        }
    }
};
AlbumPost = tslib_1.__decorate([
    Component({
        components: { AlbumCover, AlbumList, ALbumDesc, AlbumAudios, BuyAlbum }
    })
], AlbumPost);
export default AlbumPost;
